import store from '../../store/index.js'
import moment from 'moment'
import { ElLoading } from 'element-plus'
import Big from 'big.js';
/**
 * 生成随机数
 * @param type
 * @param min
 * @param max
 * @param length
 * @returns {string}
 */
export const createRandomNum = (type = 'number', min = 0, max = 100, length = 32) => {
    let randomStr = '';
    let aryType = ['number', 'string', 'uuid'];
    let hexDigits = "0123456789abcdefghijklmnopqrstwvuxyz";
    if (aryType.indexOf(type) < 0) {
        throw new Error("Input type error");
    }
    if (type === 'number') {
        if (typeof min !== 'number') {
            throw new Error("Wrong parameter type for min");
        }
        if (typeof max !== 'number') {
            throw new Error("Wrong parameter type for max");
        }
        if (typeof min === 'number' && (String(min).indexOf('-') >= 0 || String(min).indexOf('.') >= 0)) {
            throw new Error("The parameter type of min is a positive integer");
        }
        if (typeof max === 'number' && (String(max).indexOf('-') >= 0 || String(max).indexOf('.') >= 0)) {
            throw new Error("The parameter type of max is a positive integer");
        }
        if (min >= max) {
            throw new Error("Min cannot be greater than max");
        }
        randomStr = Math.round(Math.random() * (max - min + 1)) + min;
    }
    if (type === 'string') {
        if (typeof length !== 'number') {
            throw new Error("Wrong parameter type for length");
        }
        if (typeof length === 'number' && (String(length).indexOf('-') >= 0 || String(length).indexOf('.') >= 0)) {
            throw new Error("The parameter type of length is a positive integer");
        }
        randomStr = '';
        let charactersLength = hexDigits.length;
        for (let i = 0; i < length; i++) {
            randomStr += hexDigits.charAt(Math.floor(Math.random() * charactersLength));
        }
    }
    if (type === 'uuid') {
        randomStr = '';
        let s = [];
        for (let i = 0; i < 36; i++) {
            s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
        }
        s[14] = "4";
        s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
        s[8] = s[13] = s[18] = s[23];
        randomStr = s.join("");
    }
    return randomStr;
}

/**
 * 校验手机号格式
 * @param data
 * @returns {boolean}
 */
export const checkMobileFun = (data) => {
    let reg = /^1[3456789]\d{9}$/;
    let regExp = new RegExp(reg);
    return regExp.test(data);
}

/**
 * 校验邮箱格式
 * @param data
 * @returns {boolean}
 */
export const checkEmailFun = (data) => {
    let reg = /^(([^()[\]\\.,;:\s@"]+(\.[^()[\]\\.,;:\s@"]+)*)|(\\".+\\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let regExp = new RegExp(reg);
    return regExp.test(data);
}

/**
 * 判断是否是空
 * @param data
 * @returns {boolean}
 */
export const isNotEmpty = (data) => {
    if (data !== undefined && data !== null && data !== '') {
        return true;
    }
    return false;
}

/**
 * 判断是空--空字符串、空数据、空对象
 * @param {String|Array|Object} data 数据
 * @returns {boolean}
 */
export const isEmpty = (data) => {
    if (data === undefined || data === null) {
        return true;
    }
    if (typeof data === 'string' && data === "") {
        return true;
    }
    if (Array.isArray(data)) {
        if (data.length === 0) {
            return true;
        }
    }
    if (typeof data === 'object') {
        try {
            if(Object.keys(data).length === 0){
                return true;
            }
        } catch (e) {
            return true;
        }
    }
    return false;
}


/**
 * 函数防抖
 * @param fn
 * @param delay
 * @param immdiate
 * @param resultCallback
 * @returns {_debounce}
 */
export const debounce = (fn, delay = 200, immdiate = false, resultCallback) => {
    let timer = null
    let isInvoke = false

    function _debounce(...arg) {
        if (timer) clearTimeout(timer)
        if (immdiate && !isInvoke) {
            const result = fn.apply(this, arg)
            if (resultCallback && typeof resultCallback === "function") resultCallback(result)
            isInvoke = true
        } else {
            timer = setTimeout(() => {
                const result = fn.apply(this, arg)
                if (resultCallback && typeof resultCallback === "function") resultCallback(result)
                isInvoke = false
                timer = null
            }, delay)
        }
    }

    _debounce.cancel = function () {
        if (timer) clearTimeout(timer)
        timer = null
        isInvoke = false
    }
    return _debounce
}

/**
 * 下划线转驼峰
 * @param str
 * @returns {string}
 */
export const convertToCamelCase = (str) => {
    if (str === undefined || str === null || str === '') {
        return '';
    }
    if (typeof str !== 'string') {
        return '';
    }
    if (str.indexOf('_') < 0) {
        return str;
    }
    return str.toLowerCase().replace(/_(.)/g, function (match, group1) {
        return group1.toUpperCase();
    });
}
/**
 * 中划线转驼峰
 * @param str
 * @returns {string}
 */
export const strikethroughToCamelCase = (str) => {
    if (str === undefined || str === null || str === '') {
        return '';
    }
    if (typeof str !== 'string') {
        return '';
    }
    if (str.indexOf('-') < 0) {
        return str;
    }
    return str.toLowerCase().replace(/-(.)/g, function (match, group1) {
        return group1.toUpperCase();
    });
}
/**
 * 驼峰转下划线
 * @param str
 * @returns {string}
 */
export const camelToUnderscore = (str) => {
    return str.replace(/([A-Z])/g, "_$1").toLowerCase();
}
/**
 * 驼峰转中划线
 * @param str
 * @returns {string}
 */
export const camelToStrikethrough = (str) => {
    return str.replace(/([A-Z])/g, "-$1").toLowerCase();
}

/**
 * 生成层级编码
 * @param parentCode
 * @param sort
 * @param levelLength
 */
export const createLevelCode = (parentCode = '', sort = '0', levelLength = 5) => {
    let str = '';
    if (typeof parentCode === 'number') {
        parentCode = String(parentCode);
    }
    if (typeof sort === 'number') {
        sort = String(sort);
    }
    let sortLength = sort.length;
    let diffLength = levelLength - sortLength;
    if (diffLength < 0) {
        throw new Error('数据长度超出了编码长度！');
    }
    for (let i = 0; i < diffLength; i++) {
        if (i === 0) {
            str += '1';
        } else {
            str += '0';
        }
    }
    return parentCode + str + sort;
}

/**
 * 数据库字段类型转为form表单组件类型
 * @param dbType
 * @returns {string}
 * @constructor
 */
export const dbTypeToFormType = (dbType) => {

    if (['varchar', 'char'].indexOf(dbType) >= 0) {
        return 'text';
    }
    if (['text', 'longtext'].indexOf(dbType) >= 0) {
        return 'textarea';
    }
    if (['int', 'bigint', 'float', 'double'].indexOf(dbType) >= 0) {
        return 'textnumber';
    }
    if (['date'].indexOf(dbType) >= 0) {
        return 'date';
    }
    if (['datetime'].indexOf(dbType) >= 0) {
        return 'datetime';
    }

    return '';
}

/**
 * 组装url地址的参数
 * @param urlField
 * @param data
 * @param type
 * @returns {string|{}}
 */
export const assembleUrlParams = (urlField, data, type = 'str') => {
    let str = '';
    let paramObj = {};
    let aryFiled = []
    if (urlField === '') {
        return str;
    }
    if (typeof urlField === 'string') {
        aryFiled = aryFiled.split(',');
    } else {
        aryFiled = urlField;
    }
    for (let i in aryFiled) {
        let urlData = '';
        if (isNotEmpty(data[aryFiled[i]])) {
            urlData = data[aryFiled[i]];
        }
        if (type === 'str') {
            if (Number(i) === 0) {
                str = aryFiled[i] + '=' + urlData;
            } else {
                str += '&' + aryFiled[i] + '=' + urlData;
            }
        }
        if (type === 'object') {
            paramObj[aryFiled[i]] = urlData;
        }
    }
    if (type === 'str') {
        return str;
    }
    if (type === 'object') {
        return paramObj;
    }
}

/**
 * 合并数组
 * @param targetData
 * @param mergeData
 * @returns {*[]|*}
 */
export const mergeAry = (targetData, mergeData) => {
    if (typeof targetData !== 'object') {
        return [];
    }
    if (typeof mergeData !== 'object') {
        return targetData;
    }
    for (let i in mergeData) {
        targetData[i] = mergeData[i]
    }
    return targetData;
}

/**
 * 合并对象
 * @param targetData
 * @param mergeData
 * @returns {*[]|*}
 */
export const mergeObject = (targetData, mergeData) => {
    if (typeof targetData !== 'object') {
        return {};
    }
    if (typeof mergeData !== 'object') {
        return targetData;
    }
    for (let i in mergeData) {
        targetData[i] = mergeData[i]
    }
    return targetData;
}


/**
 * 按照固定长度分割字符串
 * @param str
 * @param len
 * @returns {*[]}
 */
export const splitStringByFixedLength = (str, len) => {
    let result = [];
    for (let i = 0; i < str.length; i += len) {
        result.push(str.slice(i, i + len));
    }
    return result;
}

/**
 * 补全文件路径
 * @param url 文件路径
 * @returns {string}
 */
export const formatFileUrl = (url) => {
    if (url === undefined || url === null || url === '') {
        return '';
    }
    if (typeof url !== 'string') {
        return '';
    }
    if (url.indexOf(store.state.fileUrl) < 0 && url.indexOf('http') < 0) {
        url = url.replaceAll('#','%23');
        return store.state.fileUrl + url;
    } else {
        return url;
    }

}

/**
 * 文件下载
 * @param data
 */
export const downLoadFile = (data)=>{
    let fullUrl = formatFileUrl(data.url);
    let loadIndex = ElLoading.service({
        text: '文件下载中',
        background: 'rgba(0,0,0,0.3)'
    });
    fetch(fullUrl).then(res => res.blob()).then(blob => {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = data.fileName;
        a.click();
        URL.revokeObjectURL(url);
        loadIndex.close();
    }).catch(e => {
        console.log(e);
    });
}

/**
 * 单文字转图片
 * @param text
 * @param fontSize
 * @param width
 * @param height
 * @param color
 * @param bgColor
 * @returns {string}
 */
export const singleTextToImg = (text = '张', fontSize = 20, width = 50,height = 50, color = '#333333', bgColor = '#e1e1e1') => {
    let returnStr = '';
    // 创建一个Canvas元素
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    // 设置Canvas的尺寸（例如，假设我们要创建一个包含一段文字的图像）
    canvas.width = width;
    canvas.height = height;
    // 设置背景颜色为白色
    ctx.fillStyle = bgColor;
    // 填充整个canvas区域
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    // 绘制文字到Canvas
    ctx.font = fontSize + 'px Arial';
    ctx.fillStyle = color; // 文字颜色
    let x = (width - fontSize) / 2;
    let y = (width - fontSize) / 2 + fontSize - 3;
    ctx.fillText(text, x, y); // 文字内容、x坐标、y坐标
    // 将Canvas内容转换为Data URL
    returnStr = canvas.toDataURL('image/png'); // 或 'image/jpeg' 根据需要选择图片格式
    return returnStr;
}

/**
 * @description 获取是否显示toolbar
 * @param {Array} authority 按钮编号
 * @returns {boolean}
 */
export const showTableToolbar = (authority=[])=>{
    let returnData = false;
    let pageAuthority = store.state.authority;
    if(!isEmpty(pageAuthority) && !isEmpty(authority)){
      let aryIntersection =  pageAuthority.filter(function(v){ return authority.indexOf(v) > -1 });
      if(aryIntersection.length > 0){
          returnData = true;
      }
    }
    return returnData;
}
/**
 * 排除对象中的空的字段
 * @param obj
 * @returns {{}}
 */
export const excludeObjFieldIsEmpty = (obj) => {
    if (typeof obj !== 'object') {
        throw new Error('数据类型错误！');
    }
    let newObj = JSON.parse(JSON.stringify(obj));
    for (let i in newObj) {
        if (!isNotEmpty(newObj[i])) {
            delete newObj[i];
        }
    }
    return newObj;
}

/**
 * 清除查询参数中的空数据
 */
export const handeQueryParamsEmpty = (data) => {
    for(let i in data){
        if(isEmpty(data[i])){
            delete data[i];
        }
    }
    return data;
}

// 添加日期范围
export function addDateRange(params, dateRange, propName) {
    let search = params;
    search.params = typeof (search.params) === 'object' && search.params !== null && !Array.isArray(search.params) ? search.params : {};
    dateRange = Array.isArray(dateRange) ? dateRange : [];
    if (typeof (propName) === 'undefined') {
        search.params['beginTime'] = dateRange[0];
        search.params['endTime'] = dateRange[1];
    } else {
        search.params['begin' + propName] = dateRange[0];
        search.params['end' + propName] = dateRange[1];
    }
    return search;
}

// 回显数据字典
export function selectDictLabel(datas, value) {
    if (value === undefined) {
        return "";
    }
    var actions = [];
    Object.keys(datas).some((key) => {
        if (datas[key].value == ('' + value)) {
            actions.push(datas[key].label);
            return true;
        }
    })
    if (actions.length === 0) {
        actions.push(value);
    }
    return actions.join('');
}

/**
 * 分割时间段
 * @param startTime
 * @param endTime
 * @param intervaType --month|quarter|halfYear|year
 * @returns {[{startTime: string, endTime: string}]}
 */
export const divisionTimeParagraph = (startTime,endTime,intervaType)=>{
    let aryTimeParagraph = [];
    //将时间转换为时间戳
    let thisStartTime = startTime;
    let thisEndTime = 0;
    let b = moment(endTime).unix();
    let day = 1;
    while (thisEndTime < b){
        let item = {
            startTime:moment(thisStartTime).format('YYYY-MM-DD 00:00:00'),
            endTime:"",
            payTime:""
        }
        if(thisEndTime === 0){
            //item.payTime =  moment(thisStartTime).startOf('month').add(1, 'month').startOf('month').add(2,'day').format('YYYY-MM-DD hh:mm:ss');
            //合同签订的第三天前付款
            item.payTime =  moment(thisStartTime).add(2,'day').format('YYYY-MM-DD 00:00:00');
        }else{
            item.payTime = moment(thisEndTime * 1000).format('YYYY-MM-DD 00:00:00');
        }
        switch (intervaType){
            case 'month'://月
                thisEndTime = moment(thisStartTime).add(1,'month').add('-'+day,'day').format('YYYY-MM-DD 23:59:59');
                break;
            case 'quarter'://季度
                thisEndTime = moment(thisStartTime).add(1,'quarter').add('-'+day,'day').format('YYYY-MM-DD 23:59:59');
                break;
            case 'halfYear'://半年
                thisEndTime = moment(thisStartTime).add(6,'month').add('-'+day,'day').format('YYYY-MM-DD 23:59:59');
                break;
            case 'year'://年
                thisEndTime = moment(thisStartTime).add(1,'year').add('-'+day,'day').format('YYYY-MM-DD 23:59:59');
                break;
        }
        item.endTime = depthCopyData(thisEndTime);
        aryTimeParagraph.push(item);
        //将结束时间+1天给到下次的开始时间
        thisStartTime = moment(thisEndTime).add(1,'day').format('YYYY-MM-DD 00:00:00');
        thisEndTime = moment(thisEndTime).unix();
        day = 1;
    }
    for(let i in aryTimeParagraph){
        aryTimeParagraph[i].startTime = moment(aryTimeParagraph[i].startTime).format('YYYY-MM-DD 00:00:00');
        //aryTimeParagraph[i].payTime = moment(aryTimeParagraph[i].payTime).format('YYYY-MM-DD 00:00:00');
        aryTimeParagraph[i].payTime = aryTimeParagraph[i].startTime;
        if(Number(i) === aryTimeParagraph.length - 1){
            if(moment(aryTimeParagraph[i].endTime).isAfter(endTime)){
                aryTimeParagraph[i].endTime = moment(endTime).format('YYYY-MM-DD 00:00:00');
            }else{
                aryTimeParagraph[i].endTime = moment(aryTimeParagraph[i].endTime).format('YYYY-MM-DD 00:00:00');
            }
        }else{
            aryTimeParagraph[i].endTime = moment(aryTimeParagraph[i].endTime).format('YYYY-MM-DD 00:00:00');
        }
    }
    return aryTimeParagraph;
}

/**
 * 深度拷贝数据
 * @param data
 * @returns {any}
 */
export const depthCopy = (data)=>{
    return JSON.parse(JSON.stringify(data))
}

/**
 * 时间格式化-长度截取
 * @param data
 * @param length
 * @returns {string|string|string|*|string}
 */
export const formatTimeLength = (data,length = 10)=>{
    if(isEmpty(data)){
        return '';
    }
    return  data.substr(0,length);
}

/**
 * 深度拷贝数据
 * @param data
 * @returns {any}
 */
export const depthCopyData = (data)=>{
    return JSON.parse(JSON.stringify(data));
}


/**
 * 获取当前系统时间数字
 * @returns {number}
 */
export const getSysTemTimeYMD = () => {
    const now = new Date();
    let year = now.getFullYear();
    let month = now.getMonth() + 1;
    if(month < 10){
        month = '0'+month;
    }
    let day = now.getDate();
    if(day < 10){
        day = '0'+day;
    }
    return year +'-'+ month +'-'+ day;
}

//数组2个分组
export const aryGroupTwo =(data)=>{
    let returnData = [];
    let node = [];
    for(let i in data){
        if(Number(i) > 0 && Number(i) % 2 === 1){
            node.push(data[i]);
            returnData.push(node);
            node = [];
        }else{
            node.push(data[i]);
        }
    }
    if(!isEmpty(node)){
        returnData.push(node);
    }
    return returnData;
};



/**
 * 数字相加
 * @param num1
 * @param num2
 * @returns {*}
 * @constructor
 */
export const numToPlus = (num1, num2) => {
    let a = new Big(num1);
    let b = new Big(num2);
    let c = a.plus(b).toString();
    return c;
};


/**
 * 时间格式化
 * @param {String} time --时间
 * @param {String} type --YYYY-MM-DD HH:mm:ss
 * @returns {string}
 */
export const timeFormatByType = (time,type="")=>{
    if(isEmpty(time)){
        return "";
    }
    if(isEmpty(type)){
        return time;
    }
    return  moment(time).format(type);
}
